export default __webpack_public_path__ + "static/london-de7e0b899d285634e2063399e3d38981.svg";